import React, { useRef, useState, useMemo } from 'react'

import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import InputBase from '@material-ui/core/InputBase'
import MuiSelect from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import SearchIcon from '@material-ui/icons/Search'

import MenuItem from '@material-ui/core/MenuItem'
import Checkbox from '@material-ui/core/Checkbox'

import styled from 'styled-components'
import TextSecondary from '../Typography/TextSecondary'
import Text from '../Typography/Text'

const ContainerSelect = styled(FormControl)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 36px;
  .MuiSelect-selectMenu {
    min-height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  @media (max-width: 700px) {
    width: 100%;
  }
`

const MenuItemDelete = styled(MenuItem)`
  opacity: 1 !important;
`

export const SelectStyled = styled(MuiSelect)`
  height: 36px;

  border-top-right-radius: ${({ isallfilter }) =>
    isallfilter === 'true' ? '0px' : '5px'};
  border-bottom-right-radius: ${({ isallfilter }) =>
    isallfilter === 'true' ? '0px' : '5px'};
  border-top-left-radius: ${({ isfilterleft }) =>
    isfilterleft === 'true' ? '0px' : '5px'};
  border-bottom-left-radius: ${({ isfilterleft }) =>
    isfilterleft === 'true' ? '0px' : '5px'};

  box-sizing: border-box;

  @media (max-width: 700px) {
    max-width: 100%;
    width: 100%;
  }
  .Mui-disabled {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
  }
`

const CheckboxStyled = styled(Checkbox)`
  width: 18px;
  height: 18px;
  padding-right: 20px;
  padding-top: 11px;
`
const TextSelect = styled(Text)`
  font-style: normal;
  font-weight: 500;
`

const SearchSubheader = styled(ListSubheader)`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background: ${({ theme }) =>
    theme.palette.type === 'dark' ? '#1e1e1e' : '#ffffff'};
  border-bottom: 1px solid
    ${({ theme }) =>
      theme.palette.type === 'dark' ? '#444' : '#e0e0e0'};
`

const Select = ({
  label,
  list,
  value,
  isCheckbox,
  handleDelete,
  handleDeleteAll,
  isallfilter = true,
  isfilterleft = true,
  withSearch = false,
  ...props
}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const searchInputRef = useRef(null)

  const filteredList = useMemo(() => {
    if (!withSearch || !searchQuery.trim()) return list
    const q = searchQuery.toLowerCase()
    return list?.filter(item => String(item).toLowerCase().includes(q))
  }, [list, searchQuery, withSearch])

  return (
    <ContainerSelect variant="outlined">
      <SelectStyled
        {...props}
        isallfilter={String(isallfilter)}
        isfilterleft={String(isfilterleft)}
        labelId="simple-select"
        id="simple-select"
        value={value}
        displayEmpty
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          getContentAnchorEl: null,
          onExited: () => setSearchQuery(''),
          onEntered: () => {
            if (withSearch) searchInputRef.current?.focus()
          }
        }}
        renderValue={() => {
          return <TextSelect>{label}</TextSelect>
        }}
      >
        {withSearch && (
          <SearchSubheader
            key="search-subheader"
            onClickCapture={e => e.stopPropagation()}
            onKeyDownCapture={e => e.stopPropagation()}
          >
            <SearchIcon style={{ marginRight: 8, color: '#9e9e9e', flexShrink: 0 }} />
            <InputBase
              inputRef={searchInputRef}
              placeholder="Buscar..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              fullWidth
            />
          </SearchSubheader>
        )}
        {filteredList?.map((name, index) => {
          if (name !== 'separator') {
            return (
              <MenuItem
                key={`${name}-${index}-menu`}
                value={name}
                onClick={() => handleDelete(name)}
              >
                {isCheckbox ? (
                  <CheckboxStyled
                    key={`${name}-${index}-checkbox`}
                    checked={value?.includes(name)}
                  />
                ) : null}
                <ListItemText
                  key={`${name}-${index}-item`}
                  primary={name}
                />
              </MenuItem>
            )
          } else {
            return <hr />
          }
        })}
        {isCheckbox ? (
          <MenuItemDelete
            key="borrar"
            onClick={() => handleDeleteAll(value)}
            disabled={value?.length === 0}
          >
            <TextSecondary>Borrar selección</TextSecondary>
          </MenuItemDelete>
        ) : null}
      </SelectStyled>
    </ContainerSelect>
  )
}

export default Select
